import { useEffect } from "react";

export default function useWindowEventListener(name, handler) {
  useEffect(() => {
    if (!name) {
      return () => {};
    }

    if (Array.isArray(name)) {
      name.forEach(singleName => window.addEventListener(singleName, handler));
      return () => {
        name.forEach(singleName => window.removeEventListener(singleName, handler));
      };
    }

    window.addEventListener(name, handler);

    return () => {
      window.removeEventListener(name, handler);
    };
  }, [name, handler]);
}
